import {APP_INITIALIZER, ApplicationConfig, ErrorHandler,} from '@angular/core';
import {provideRouter, Router} from '@angular/router';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import * as Sentry from '@sentry/angular';
import {routes} from './app.routes';
import {PasswordProtector} from './utils/passwordProtector.service';
import {provideHttpClient} from "@angular/common/http";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(),
    {
      provide: PasswordProtector,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
};
